import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";

const UserDeactivationCounter = withLiteObserverAndTheme<{
  counter: number;
  isUserDeactivated: boolean;
}>((props) => {
  const { theme, counter, isUserDeactivated } = props;
  const { colors } = theme;

  return isUserDeactivated ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={50}
      height={36}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{
        border: `1px dashed ${colors.all.black}`
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={25}
        text={`${counter}`}
        isSpan={false}
        color={colors.all.maastrichtBlue}
        style={{
          color: colors.all.white
        }}
      />
    </ET3Div>
  ) : null;
});

export default UserDeactivationCounter;
